module.exports = __webpack_public_path__ + "img/money-exchange.dbb83252.png";